<template>
  <el-container style="height: 100%;">
    <Aside />
  <el-container>
    <Header />
    <el-main style="margin: 20px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); background-color:#F5F5F5" ref="main">
      <router-view :key="key" />
    </el-main>
    <el-footer style="height: 40px;padding: 0px;text-align: center;">
      &copy;CopyRight 2020-2020 BrainstormHK Inc All Rights Reserved. BrainstormHK Technical support.
    </el-footer>
  </el-container>
</el-container>
</template>

<script>
import {Header, Aside} from './components'

export default {
  name: 'layout',
  components: {
    Header,
    Aside
  },
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/index.vue